<template>
  <div class="w-100" style="min-height:38px;text-align:left;">
    <b-form>
      <b-form-group 
        label="Indique su tipo de dieta"
        label-for="input-diet">
        <b-form-select id="input-diet"
          v-model="formData.diet_type"
          :options="options.optionsDietType"
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group
        label="Marque los alimentos a los cuales es alérgico/a:"
        label-for="input-allergies">
        <b-form-checkbox-group id="input-allergies"
          v-model="formData.allergies"
          :options="options.optionsAllergies"
          :disabled="disabled"
        />
      </b-form-group>
      <transition name="other-field-transition">
        <b-form-group
          v-if="otherAllergieSelected"
          label="Indica tus otras alergias"
          label-for="input-allergies_detail"
        >
          <b-form-textarea 
            id="input-allergies_detail" 
            v-model="formData.allergies_detail" 
            rows="2" 
            max-rows="2" 
            no-resize
            aria-describedby="input-allergies_detail-feedback"
            :state="$v.formData.allergies_detail.$invalid ? false : null "
            :disabled="disabled"
          />
          <b-form-invalid-feedback id="input-allergies_detail-feedback">
            El texto es demasiado largo
          </b-form-invalid-feedback>
        </b-form-group>
      </transition>
      <b-form-group
        label="Marque los alimentos que no consume o no le gustan:"
        label-for="input-rejected">
        <b-form-checkbox-group id="input-rejected"
          v-model="formData.rejected_foods"
          :options="options.optionsRejectedFoods"
          :disabled="disabled"
        />
      </b-form-group>
      <transition name="other-field-transition">
        <b-form-group
          v-if="otherRejectedFoodSelected"
          label="Indica los otros alimentos que no consumes"
          label-for="input-rejected_foods_detail"
        >
          <b-form-textarea 
            id="input-rejected_foods_detail" 
            v-model="formData.rejected_foods_detail" 
            rows="2" 
            max-rows="2" 
            no-resize
            aria-describedby="input-rejected_foods_detail-feedback"
            :state="$v.formData.rejected_foods_detail.$invalid ? false : null "
            :disabled="disabled"
          />
          <b-form-invalid-feedback id="input-rejected_foods_detail-feedback">
            El texto es demasiado largo
          </b-form-invalid-feedback>
        </b-form-group>
      </transition>
      <b-form-group
        label="¿Qué tipo de alimentos prefiere consumir?"
        label-for="input-junkfood">
        <b-form-select id="input-junkfood"
          v-model="formData.junk_food_preference"
          :options="options.optionsJunkFoodPreference"
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group 
        label="Marque si es que presenta alguno de estos síntomas digestivos:"
        label-for="input-digestive">
        <b-form-checkbox-group id="input-digestive" 
          v-model="formData.digestive_symptoms" 
          :options="options.optionsDigestiveSymptoms"
          :disabled="disabled"
        />
      </b-form-group>
      <transition name="other-field-transition">
        <b-form-group
          v-if="otherDigestiveSymptomSelected"
          label="Indica tus otros síntomas digestivos"
          label-for="input-digestive_symptoms_detail"
        >
          <b-form-textarea 
            id="input-digestive_symptoms_detail" 
            v-model="formData.digestive_symptoms_detail" 
            rows="2" 
            max-rows="2" 
            no-resize
            aria-describedby="input-digestive_symptoms_detail-feedback"
            :state="$v.formData.digestive_symptoms_detail.$invalid ? false : null "
            :disabled="disabled"
          />
          <b-form-invalid-feedback id="input-digestive_symptoms_detail-feedback">
            El texto es demasiado largo
          </b-form-invalid-feedback>
        </b-form-group>
      </transition>
      <DailyConsumptionTable
        ref="dailyTable"
        v-model="formData.daily_consumptions"
        :options-meals="options.optionsMeals"
        :disabled="disabled"
      />
      <WeeklyConsumptionTable 
        ref="weeklyTable"
        v-model="formData.weekly_consumptions"
        :options-trend-foods="options.optionsTrendFoods"
        :options-trend-times="options.optionsTrendTimes"
        :disabled="disabled"
      />
      <b-form-group
        label="Agrega información importante sobre tu nutrición que no haya sido mencionada"
        label-for="input-extra_nutri_info"
      >
        <b-form-textarea 
          id="input-extra_nutri_info" 
          v-model="formData.extra_nutritional_info" 
          rows="2" 
          max-rows="6" 
          aria-describedby="input-extra_nutri_info-feedback"
          :state="$v.formData.extra_nutritional_info.$invalid ? false : null "
          :disabled="disabled"
        />
        <b-form-invalid-feedback id="input-extra_nutri_info-feedback">
          El texto es demasiado largo
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import DailyConsumptionTable from "../table/DailyConsumptionTable";
import WeeklyConsumptionTable from "../table/WeeklyConsumptionTable";
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: "NutritionalPollComponent",
  components: { 
    DailyConsumptionTable , 
    WeeklyConsumptionTable 
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      formData: {
        digestive_symptoms: [],
        digestive_symptoms_detail: "",
        diet_type: "",
        allergies: [],
        allergies_detail: "",
        rejected_foods: [],
        rejected_foods_detail: "",
        junk_food_preference: "",
        daily_consumptions: [],
        weekly_consumptions: [],
        extra_nutritional_info: ""
      },
      options: {
        optionsDigestiveSymptoms: [
          { value: 1, text: "Diarrea" },
          { value: 2, text: "Constipación" },
          { value: 3, text: "Hinchazón" },
          { value: 4, text: "Malestar" },
          { value: 5, text: "Otro" }
        ],
        optionsDietType: [
          { value: 1, text: "Omnívoro (incluye todos los alimentos)" },
          { value: 2, text: "Vegetariano" },
          { value: 4, text: "Pesco vegetariano"},
          { value: 3, text: "Vegano" }
        ],
        optionsAllergies: [
          { value: 1, text: "Lactosa" },
          { value: 2, text: "Proteína de leche de vaca" },
          { value: 3, text: "Maní" },
          { value: 4, text: "Soya" },
          { value: 5, text: "Chocolate" },
          { value: 6, text: "Palta" },
          { value: 7, text: "Trigo o gluten" },
          { value: 8, text: "Huevo" },
          { value: 9, text: "Mariscos" },
          { value: 10, text: "Otro" }
        ],
        optionsRejectedFoods: [
          { value: 1, text: "Lácteos" },
          { value: 2, text: "Carnes rojas" },
          { value: 3, text: "Carnes blancas" },
          { value: 4, text: "Mariscos" },
          { value: 5, text: "Huevos" },
          { value: 6, text: "Verduras" },
          { value: 7, text: "Frutas" },
          { value: 8, text: "Otro" }
        ],
        optionsJunkFoodPreference: [
          { value: 1, text: "Dulces (chocolate, pasteles, etc)" },
          { value: 2, text: "Saladas (papas fritas, hamburguesas, etc)" },
          { value: 3, text: "Ambas" },
          { value: 4, text: "Ninguna" },
        ],
        optionsTrendFoods: [
          { value: 1, text: "Lácteos" },
          { value: 2, text: "Verduras" },
          { value: 3, text: "Frutas" },
          { value: 4, text: "Frutos secos" },
          { value: 5, text: "Alcohol" },
          { value: 6, text: "Dulces (chocolate, pasteles, etc)" },
          { value: 7, text: "Comida chatarra (completos, frituras, etc)" }
        ],
        optionsTrendTimes: [
          { value: 0, text: "0 días (0 / 7)" },
          { value: 1, text: "1 día (1 / 7)" },
          { value: 2, text: "2 días (2 / 7)" },
          { value: 3, text: "3 días (3 / 7)" },
          { value: 4, text: "4 días (4 / 7)" },
          { value: 5, text: "5 días (5 / 7)" },
          { value: 6, text: "6 días (6 / 7)" },
          { value: 7, text: "7 días (7 / 7)" }
        ],
        optionsMeals: [
          { value: 1, text: "Desayuno" },
          { value: 2, text: "Almuerzo" },
          { value: 3, text: "Once" },
          { value: 4, text: "Cena" },
          { value: 5, text: "Colación" }
        ]
      }
    }
  },
  validations: {
    formData:{
      allergies_detail: {
        maxLength: maxLength(300)
      },
      rejected_foods_detail: {
        maxLength: maxLength(300)
      },
      digestive_symptoms_detail: {
        maxLength: maxLength(300)
      },
      extra_nutritional_info: {
        maxLength: maxLength(1000)
      },
    }
  },
  methods: {
    loadData: function(data) {
      this.formData = data
      this.$refs.dailyTable.loadData(data.daily_consumptions)
      this.$refs.weeklyTable.loadData(data.weekly_consumptions)
    },
    validate: function () {
      this.$v.formData.$touch()
      let isValid =  this.$refs.dailyTable.validate() 
        && this.$refs.weeklyTable.validate() 
        && !this.$v.formData.$invalid
      this.$emit('on-validate', isValid)
      return isValid
    }
  },
  computed: {
    otherAllergieSelected: function () {
      let allergies = this.formData.allergies
      if (allergies) {
        return allergies.includes(10)
      }
      return false
    },
    otherRejectedFoodSelected: function () {
      let foods = this.formData.rejected_foods
      if (foods) {
        return foods.includes(8)
      }
      return false
    },
    otherDigestiveSymptomSelected: function () {
      let symptoms = this.formData.digestive_symptoms
      if (symptoms) {
        return symptoms.includes(5)
      }
      return false
    },
  }
};
</script>

<style>
.other-field-transition-enter-active,
.other-field-transition-leave-active {
  transition: opacity 0.3s;
}

.other-field-transition-enter,
.other-field-transition-leave-to {
  opacity: 0;
}

.other-field-transition-leave,
.other-field-transition-enter-to {
  opacity: 1;
}
</style>